import React, { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import StandaloneInput from '../../components/Form/StandaloneInput'
import { useBusinessLocation } from '../../context/BusinessLocationContext'

interface SelectLocationModalProps {
  open: boolean
  onClose: () => void
}

export const SelectLocationModal: React.FC<SelectLocationModalProps> = ({
  open,
  onClose,
}) => {
  const [search, setSearch] = useState('')

  const { availableLocations, setLocation } = useBusinessLocation()

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg w-full bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md sm:p-6">
                <Dialog.Title
                  as="h3"
                  className="text-base font-semibold leading-6 text-gray-900"
                >
                  Select location
                </Dialog.Title>
                <div id="search-wrapper" className={'flex-1 relative mt-4'}>
                  <div
                    className={
                      'absolute left-0 top-0 bottom-0 pl-4 flex items-center'
                    }
                  >
                    <MagnifyingGlassIcon className={'w-5 h-5 text-gray-500'} />
                  </div>
                  <StandaloneInput
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    className={'h-12 w-100 pl-11'}
                    placeholder={'Search for locations'}
                  />
                </div>
                <ul className="mt-4 divide-y divide-gray-200 max-h-32 overflow-y-scroll">
                  {availableLocations
                    .filter(location =>
                      search === ''
                        ? true
                        : location.name
                            ?.toLowerCase()
                            .includes(search.toLowerCase())
                    )
                    .map(location => (
                      <button
                        key={location.id}
                        onClick={() => {
                          setLocation(location)
                          onClose()
                        }}
                        className={
                          'w-full flex flex-col px-4 pl-0 py-2 text-sm text-left text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                        }
                      >
                        <span className={'font-medium'}>{location.name}</span>
                        <span className={'text-gray-500'}>
                          {location.formattedAddress}
                        </span>
                      </button>
                    ))}
                </ul>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
